import * as React from "react";
import { Select } from "antd";
import { ServiceContext } from "src/services/provider/Service.provider";
import { useContext, useState, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { IBankOwner } from 'src/services/interfaces/trade/tradeOwner/IBankOwner';
import { ISelectBankList } from 'src/services/interfaces/ISelectBankList';

interface ISelectBankNameProps extends FormComponentProps {
  bankData: IBankOwner;
  onChange: (value: string) => void;
  isBankRequired: boolean;
}

export const SelectBankName: React.FC<ISelectBankNameProps> = ({ bankData, onChange, form, isBankRequired }) => {
  const { commonDomainService } = useContext(ServiceContext);
  const [selectList, setSelectList] = useState<ISelectBankList[]>([]);

  useEffect(() => {
    loadBankList();
  }, []);

  function loadBankList() {
    commonDomainService.getBankList().then(resp => {
      setSelectList(resp.bank_configuration_json);
    });
  }

  return (
    <>
      <PbrSelect
        name="bank"
        size="large"
        formItemProps={{ label: "Banco" }}
        formWrapper={form}
        showSearch
        value={bankData?.bank}
        onChange={e => onChange(e.toString())}
        placeholder="Selecione o banco"
        rules={[{ required: isBankRequired, message: "Informe o banco" }]}
      >
        {selectList.map(({ code, name }, i) => (
          <Select.Option key={i.toString()} value={code}>{`${code} - ${name}`}</Select.Option>
        ))}
      </PbrSelect>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/SelectBankName/SelectBankName.tsx